import { Input, Spin } from "antd";
import React, { useEffect, useState } from "react";
// import { generatePDF, getAuction, getCarinfoByVin, getSaleHistory, marketValue } from "../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const schema = yup.object().shape({
  vin: yup.string().required('VIN is required'),
  modelYear: yup.string().required('Model year is required'),
  make: yup.string().required('Make is required'),
  model: yup.string().required('Model is required'),
  trim: yup.string().required('Trim level is required'),
  paintCode: yup.string().required('Paint code is required'),
  mileage: yup.string().required('Mileage is required'),
  city: yup.string().required('Zip code is required'),
  condition: yup.string().required('Condition is required'),
  primaryDamage: yup.string().required('Primary damage is required'),
  drivableStatus: yup.string().required('Drivable status is required'),
  repairCosts: yup.string().required('Repair costs are required'),
  acv: yup.string().required('Actual Cash Value is required'),
  tlv: yup.string().required('Total Loss Value is required'),
  costOfRepair: yup.string().required('Estimated cost of repair is required'),
  totalLossStatus: yup.string().required('Total Loss Status is required'),
});

const FormPage = () => {
  let { vin } = useParams();
  const navigate = useNavigate();
  const [value, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({});
  const [carInfo, setCarInfo] = useState({});
  const [salesHistory, setSalesHistory] = useState([]);
  const [auction, setAuction] = useState([]);
  const handleChange = (val, key) => {
    setValues({ ...value, [key]: val });
  }
  // useEffect(() => {
  //   setLoading(true);
  //   if (vin) {
  //     getInitialData();
  //   }
  // }, [vin]);

  // const getInitialData = async () => {
  //   try {
  //     const [carInfoResponse, marketValueResponse, saleHistoryResponse, auctionResponse] = await Promise.all([
  //       getCarinfoByVin(vin),
  //       marketValue(vin),
  //       getSaleHistory(vin),
  //       getAuction(vin),
  //     ]);
  //     if (carInfoResponse?.data) {
  //       setCarInfo(carInfoResponse.data);
  //     }
  //     if (marketValueResponse?.data?.data) {
  //       setDetails(marketValueResponse.data.data);
  //     }
  //     if (saleHistoryResponse.data.result) {
  //       setSalesHistory(saleHistoryResponse.data.result);
  //     }
  //     if (auctionResponse.data.result) {
  //       setAuction(auctionResponse.data.result);
  //     }
  //   } catch (e) {
  //     console.error(e)
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  // const handleSubmit = () => {
  //   setLoading(true)
  //   let auctionData = auction?.length ? auction : "NA";
  //   let salesHistoryData = salesHistory?.data ? salesHistory?.data : "NA";
  //   generatePDF({ ...value, ...details, ...carInfo, auctionData, salesHistoryData })
  //     .then((res) => {
  //       const url = window.URL.createObjectURL(new Blob([res.data]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', `${vin}.pdf`);
  //       document.body.appendChild(link);
  //       link.click();
  //       setLoading(false);
  //     })
  //     .catch(() => setLoading(false));
  // }
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });
  console.log("error", errors);

  const onSubmit = data => {
    const { make, model, trim, city } = data;
    if (data) {
      navigate('/find_car', {
        state: { formInputValues: data, filterInput: { make, model, trim, city } },
      })
    }
  };

  return (<>
    <div className="p-4 md:p-8">
      <Spin
        spinning={loading}
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 48,
              color: 'black',
            }}
            spin
          />
        }
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="bg-white p-6 md:p-8 shadow-md w-full md:w-[80%] mx-auto"
        >
          <h1 className="text-center text-xl md:text-2xl font-bold">Condition Report</h1>

          <div className="p-5 flex flex-col md:flex-row gap-6">

            {/* Left Section */}
            <div className="w-full md:w-1/2">
              {[
                { label: "VIN", name: "vin" },
                { label: "Model Year", name: "modelYear" },
                { label: "Make", name: "make" },
                { label: "Model", name: "model" },
                { label: "Trim Level", name: "trim" },
                { label: "Paint Code", name: "paintCode" },
                { label: "Mileage", name: "mileage" },
                { label: "Zip Code", name: "city" },
              ].map(({ label, name }) => (
                <div key={name} className="mb-4">
                  <p className="text-xs font-light pb-1">{label}</p>
                  <Controller
                    name={name}
                    control={control}
                    render={({ field }) => <Input {...field} />}
                  />
                  {errors[name] && <p className="text-red-500 text-xs">{errors[name].message}</p>}
                </div>
              ))}
            </div>

            {/* Right Section */}
            <div className="w-full md:w-1/2">
              {[
                { label: "Condition", name: "condition" },
                { label: "Primary Damage", name: "primaryDamage" },
                { label: "Drivable Status", name: "drivableStatus" },
                { label: "Repair Costs", name: "repairCosts" },
                { label: "Actual Cash Value (ACV)", name: "acv" },
                { label: "Total Loss Value (TLV)", name: "tlv" },
                { label: "Estimated Cost of Repair", name: "costOfRepair" },
                { label: "Total Loss Status", name: "totalLossStatus" },
              ].map(({ label, name }) => (
                <div key={name} className="mb-4">
                  <p className="text-xs font-light pb-1">{label}</p>
                  <Controller
                    name={name}
                    control={control}
                    render={({ field }) => <Input {...field} />}
                  />
                  {errors[name] && <p className="text-red-500 text-xs">{errors[name].message}</p>}
                </div>
              ))}
            </div>

          </div>

          {/* Submit Button */}
          <div className="w-full flex justify-center mt-6">
            <button type="submit" className="min-w-[200px] md:min-w-[303px] py-4 md:py-5 darkBlue text-lg text-white">
              Submit
            </button>
          </div>

        </form>
      </Spin>
    </div>
  </>
  );
};

export default FormPage;
